import React from 'react';
import {View} from 'MWC';
import PropTypes from 'prop-types';
import tpl from '../../templates/landing/kdv-new.jsx';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: []
        };

        this.crefs = {};
        this.widgetsHelper = widgetsHelper;
        return this;
    }

    static displayName = 'Cards.KDV';

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
    }

    static contextTypes = {
        app: PropTypes.object,
        history: PropTypes.object
    };
}
